import { action, computed, observable } from 'mobx';
import { SpeechesData } from './SpeechesData';
import { YearData } from './YearData';

export class YearsData {
    @observable scrollElement: HTMLElement;
    @action setRef = (value: HTMLElement) => {
        this.scrollElement = value;
    };

    constructor(private speeches: SpeechesData) {}

    @computed get data(): YearData[] {
        return this.speeches.years.map(y => new YearData(this, y));
    }

    @computed get visibleElements(): YearData[] {
        return this.data.filter(y => y.isVisible);
    }

    @computed get firstVisibleIndex(): number {
        const element = this.visibleElements[0];
        return this.data.indexOf(element);
    }

    @computed get lastVisibleIndex(): number {
        const element = this.visibleElements.reverse()[0];
        return this.data.indexOf(element);
    }

    @computed get leftInvisibleElement(): YearData {
        if (this.firstVisibleIndex > -1) {
            return this.data[this.firstVisibleIndex - 1];
        }
    }

    @computed get rightInvisibleElement(): YearData {
        if (this.lastVisibleIndex > -1) {
            return this.data[this.lastVisibleIndex + 1];
        }
    }

    @computed get activeElement(): YearData {
        return this.data.find(y => y.isActive);
    }

    @computed get activeSide(): 'left' | 'right' {
        const activeIndex = this.data.indexOf(this.activeElement);
        if (this.leftInvisibleElement && this.firstVisibleIndex > activeIndex) {
            return 'left';
        }
        if (this.rightInvisibleElement && this.lastVisibleIndex < activeIndex) {
            return 'right';
        }
    }
}
